import React from 'react';
import './topnav.css';
import { NavLink } from 'react-router-dom';

import logoicon from '../assets/logoicon.png';
import bell from '../assets/bell.svg';
import user from '../assets/profile.svg';

const Topnav = () => {
  return (
    <header className='top_nav'>

      <img className='top_logo' src={logoicon} alt='' />

      <div className='top_right'>

        <NavLink className='top_icon_btn' to='/notifications' aria-label='Notifications'>
          <img src={bell} alt='' />
        </NavLink>

        <NavLink className='top_icon_btn' to='/profile' aria-label='Profile'>
          <img src={user} alt='' />
        </NavLink>

      </div>

    </header>
  );
}

export default Topnav;
